import { memo, type ReactElement } from 'react';

import './GroupedTableHeader.scss';
import { ControlDescriptor, Controls, GroupedTableClassNames, TableState } from 'components/GroupedList';

export interface GroupedTableHeaderProps<I, G> {
  icon: ReactElement;
  text: ReactElement | string;
  controls: ControlDescriptor<I, G>[];
  tableState: TableState;
  classNames?: Partial<GroupedTableClassNames>;
  onExpandAll: () => void;
  onCollapseAll: () => void;
  updateTableState: (changes: Partial<TableState>) => void;
}

const getEntityIdStub = () => 1;

const GroupedTableHeader = <I, G>({
  icon,
  text,
  controls,
  classNames,
  tableState,
  onExpandAll,
  onCollapseAll,
  updateTableState,
}: GroupedTableHeaderProps<I, G>) => (
  <div className="gt-header">
    <h3 className="text-primary gt-header__title">
      {icon}
      {text}
    </h3>
    <div className="gt-header__buttons">
      {controls?.length && (
        <Controls
          entity={null}
          groups={null}
          controls={controls}
          rowState={tableState}
          classNames={classNames}
          getEntityId={getEntityIdStub}
          updateRowState={updateTableState}
        />
      )}
      {[true, false].map((expand) => (
        <button
          key={expand ? 'expand' : 'collapse'}
          type="button"
          onClick={expand ? onExpandAll : onCollapseAll}
          className="btn btn-sm btn-tool-box gt-header__button"
        >
          <i className={`fa fa-caret-${expand ? 'down' : 'right'}`} />
          &nbsp;
          {translate(expand ? 'Expand all' : 'Collapse all')}
        </button>
      ))}
    </div>
  </div>
);

// eslint-disable-next-line import/no-default-export
export default memo(GroupedTableHeader);
